export default {
	SET_SG_HOLIDAYS: "SET_SG_HOLIDAYS"
};
